import { FormaEnvio } from './../../model/geral/formaEnvio';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';

@Injectable({
  providedIn: 'root'
})
export class FormaEnvioService extends GenericService<FormaEnvio>{
  constructor(http: HttpClient) { 
    super(http);
    super.initResource("formaenvio")
  }
}
